/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { stopListItemSchema } from "./stopListItemSchema.ts";

export const updateStopListSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string(),
	items: z.array(stopListItemSchema),
});
